/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  ISendPurchaseInviteMethods,
  SendPurchaseInviteUserService,
  GetInviteUserService,
  IGetInviteUserMethods,
  SendPurchaseInviteUserProps,
  ValidateReferralProps,
  ValidateReferralService,
  IValidateReferalMethods,
} from "./components";

export type OpenRegisterPageAgent = IStaticPageContentMethods &
  IGetInviteUserMethods &
  ISendPurchaseInviteMethods &
  IValidateReferalMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),

    new SendPurchaseInviteUserService(),
    new GetInviteUserService(),
    new ValidateReferralService(),
  ];
};

export const getAgent = () => {
  return createAgent<OpenRegisterPageAgent>({
    plugins: getPlugins(),
  });
};
